import React, {useState} from 'react';
import intl from 'react-intl-universal';
import {observer} from 'mobx-react-lite';

import {useAppState, useUserState} from '@stores/AppStateContext';
import type {AuditTemplate} from '../../../stores/audit/types';
import {Button} from '../../components/Button/Button';
import {getMuiIcon} from '../../components/icons/createMuiIcon';
import {MoreVerticalIcon} from '../../components/icons/MoreVerticalIcon';
import {Tooltip} from '../../components/Tooltip/Tooltip';
import {openAuditRowOptions} from '../../elements/context-menu/AuditRowOptions/AuditRowOptions';
import {AuditDeleteConfirmModal} from './AuditDeleteConfirmModal';

export interface AuditRowActionsProps {
    template: AuditTemplate;
    onRunClick?: (template: AuditTemplate) => void;
}

export const AuditRowActions = observer(({template, onRunClick}: AuditRowActionsProps) => {
    const appState = useAppState();
    const userState = useUserState();
    const [deleteTemplate, setDeleteTemplate] = useState<AuditTemplate | null>(null);
    const isReadOnly = userState?.isCurrentUserReadOnly;
    const published = template.publicationState === 'published';

    return (
        <>
            <div className="Audits-rowActions" onClick={(event) => event.stopPropagation()}>
                {published ? (
                    <Button
                        type="neutral"
                        style="plain"
                        size="sm"
                        Icon={getMuiIcon('play_circle')}
                        text={intl.get('audits.list.run').d('Run')}
                        onClick={() => onRunClick?.(template)}
                    />
                ) : null}
                {!isReadOnly ? (
                    <Tooltip title={intl.get('tooltip.more').d('More')}>
                        <MoreVerticalIcon
                            className="Audits-rowActions__more"
                            size={20}
                            onClick={(event) => {
                                const target = event.currentTarget;
                                event.preventDefault();
                                event.stopPropagation();
                                openAuditRowOptions(appState, template, {
                                    getTargetBoundingBox: () => target.getBoundingClientRect(),
                                    menuAlignment: 'end',
                                }, setDeleteTemplate);
                            }}
                        />
                    </Tooltip>
                ) : null}
            </div>
            <AuditDeleteConfirmModal
                template={deleteTemplate}
                onClose={() => setDeleteTemplate(null)}
            />
        </>
    );
});
